import { MilestoneStatuses } from '@insurancemenu/imenu-components-lib/dist/types';
import { ChecklistButtonStateText } from 'types/enrollmentService';

export const calculateMilestoneStatus = (buttonState: ChecklistButtonStateText): MilestoneStatuses => {
  switch (buttonState) {
    case ChecklistButtonStateText.VIEW_EDIT:
    case ChecklistButtonStateText.VIEW:
      return MilestoneStatuses.COMPLETED;
    case ChecklistButtonStateText.UNAVAILABLE:
      return MilestoneStatuses.INACTIVE;
    case ChecklistButtonStateText.CONTINUE:
      return MilestoneStatuses.ACTIVE;
    default:
      return MilestoneStatuses.INACTIVE;
  }
};
